<template>
  <div class="industries-columns">
    <p v-if="!isMobileAds" class="has-text-centered">
      <fuse-ad name="sub_industries_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad :ad-object="firstAd" :no-margin="hideFirstDesktopAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
      <!-- <ad :ad-object="secondAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
    </p>
    <p v-if="isMobileAds" class="has-text-centered">
      <fuse-ad name="sub_industries_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad :ad-object="firstAd" :no-margin="hideFirstDesktopAd" v-on:ad-loaded="updateAdsListForPage" :force-fluid="hideFirstDesktopAd"></ad> -->
    </p>

    <div :class="{'margin-bottom-23':!isMobile, 'margin-bottom-13':isMobile}" class="margin-top-20">
      <img alt="Back to list" class="valign-middle margin-right-4" src="/static/img/arrows/arrow_left_blue.svg"/>
      <router-link :class="{'font-size-14':!isMobile}"
                   :to="{ name: 'IndustryLanding' }" class="link--v2">
        Back to all categories
      </router-link>
    </div>

    <div :class="{'flex-dir-col':isMobile}" class="is-flex margin-bottom-16">
      <span :class="{'margin-right-11':!isMobile, 'margin-bottom-8':isMobile}" class="padding-top-5 color-blue-dark has-text-weight-semibold">{{
          industryDetail.name
        }}:</span>
      <span>
        <router-link :class="{'pill--selected': !subIndSlug && indSlug === industryDetail.slug}"
                     :to="{ name: 'Industries-Category', params: { slug: industryDetail.slug } }" class="pill">
          All
        </router-link>
        <router-link v-for="(subIndustry, index) in industryDetail.sub_industries" :key="index"
                     :class="{'pill--selected': subIndSlug && subIndSlug === subIndustry.slug}"
                     :to="{ name: 'SubIndustriesDetail', params: { indSlug: industryDetail.slug, subIndSlug: subIndustry.slug } }"
                     class="pill">
          {{ subIndustry.name }}
        </router-link>
      </span>
    </div>

    <p v-if="!isMobileAds" class="is-hidden">
      <!-- <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdsListForPage" :force-fluid="hideFirstDesktopAd"></ad> -->
    </p>
    <p v-if="!isMobileAds" class="has-text-centered">
      <fuse-ad name="sub_industries_incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad :ad-object="fourthAd" v-on:ad-loaded="updateAdsListForPage" :force-fluid="hideFirstDesktopAd"></ad> -->
    </p>
    <p v-if="isMobileAds" class="has-text-centered">
      <fuse-ad name="sub_industries_incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad :ad-object="secondAd" v-on:ad-loaded="updateAdsListForPage" :force-fluid="hideFirstDesktopAd"></ad> -->
    </p>

    <div>
      <p :class="{'font-size-32':!isMobile, 'font-size-14':isMobile}"
         class="hp-heading margin-bottom-3">Best in {{ nameForBestIn }}</p>
      <!--      <p :class="{'margin-bottom-9':!isMobile, 'margin-bottom-4':isMobile}">
              <strong>226 518</strong> Reviews
              <img alt="|" class="valign-middle margin-left-14 margin-right-16" src="/static/img/others/pipe.svg"/>
              <strong>990</strong> Businesses
            </p>-->
      <a v-if="1 === 2" :class="{'font-size-10':isMobile}" class="link" href="#">Why Compare {{ nameForBestIn }}
        Companies on
        Hellopeter</a>
    </div>

    <div :class="{'flex-dir-col':isMobile}" class="margin-top-19 is-flex">
      <div>
        <span class="is-inline-block margin-top-9">Filter by:</span>
        <bulma-dropdown :class="{'margin-right-39':!isMobile}" :ddLabel="bizStatusDd.label"
                        :ddOptions="bizStatusDd.options" class="margin-left-9" @bulmaDdChange="bizStatusChangeHandler"/>
      </div>
      <div :class="{'margin-top-9':isMobile}">
        <span class="is-inline-block margin-top-9">Sort by:</span>
        <bulma-dropdown :class="{'margin-left-9':!isMobile, 'margin-left-13':isMobile}" :ddLabel="sortByDd.label"
                        :ddOptions="sortByDd.options" @bulmaDdChange="sortChangeHandler"/>
      </div>
    </div>

    <hr class="separator" ref="bizList"/>

    <alert-message
        v-if="industryBusinesses.businesses.length || pagingTrack.currentPage !== 1"
        :class="{'margin-bottom-25':!isMobile, 'margin-bottom-14':isMobile}"
        type="info">
      To rank in best categories, a business must actively reply to reviews and have received 12 or more reviews in the
      rolling 12 months.
    </alert-message>

    <div>
      <flash-message class="margin-bottom-20" size="is-size-6"/>
      <p v-if="isFetchingIndustryBusinesses" class="has-text-centered spinner">
        <img alt="Getting review detail" src="/static/img/others/spinner.svg"/>
      </p>
      <template v-else>
        <template v-if="!industryBusinesses.businesses.length">
          <biz-no-result v-if="pagingTrack.currentPage === 1"/>
          <div v-else class="results-ended">
            <p>The end of your search result</p>
            <p>
              <img src="/static/img/magnifier/magnifier.webp"
                   srcset="/static/img/magnifier/magnifier@2x.webp 1.5x,
           /static/img/magnifier/magnifier@2x.webp 2x,
             /static/img/magnifier/magnifier@3x.webp 3x"
              />
            </p>
            <router-link :class="{'font-size-14':!isMobile}"
                         :to="{ name: 'IndustryLanding' }" class="link--v2 has-text-weight-normal">
              Back to all categories
            </router-link>
          </div>
        </template>
        <template v-else>
          <biz-row-card v-for="(business, idx) in industryBusinesses.businesses" :key="idx" :showRanking="showRanking"
                        :bizDetails="{subscName:business.subsc_name_key.buckets[0].key, bizLogo:business.business_logo_key.buckets[0].key, bizName:business.business_name_key.buckets[0].key, rating: business.average_rating.value, reviewsCount: business.total_reviews.value, trustIndex: business.finalTrustIndex.value, indusName:nameForBestIn, rank: calcBizRank(idx), avgReplyTime: business.average_time_to_reply.value, nps: business.nps_key.buckets, slug: business.business_slug_key.buckets[0].key}"/>
        </template>
        <div :class="{'margin-top--6': isMobile}" class="has-text-centered">
          <template v-if="pagingTrack.currentPage > 1">
            <a class="hp-btn-pagination hp-btn-pagination--hollow" :class="{'margin-bottom-5': isMobile}" href="#" @click.prevent="resetPaging">First</a>
            <a class="hp-btn-pagination hp-btn-pagination--hollow" href="#" @click.prevent="prevPageHandler">Prev</a>
          </template>
          <a
              v-if="industryBusinesses.businesses.length || pagingTrack.currentPage !== 1"
              :class="{'margin-left-22': !isMobile, 'hp-btn-pagination--disabled': industryBusinesses.businesses.length < 10}"
              class="hp-btn-pagination" href="#"
              @click.prevent="nextPageHandler">Next</a>
        </div>
      </template>
    </div>

    <div v-if="1 === 2" class="page-width-box compareBox">
      <div class="compareBox__cont">
        <p :class="{'font-size-18': !isMobile}" class="color-blue has-text-weight-bold margin-bottom-13">Compare
          {{ nameForBestIn }} Companies on
          Hellopeter</p>
        <p :class="{'font-size-14': !isMobile, 'font-size-11': isMobile}" v-html="compareDescTextTrimmed"></p>
        <p v-if="compareDescTextRaw.length > compareDescCharsShow" class="is-clearfix margin-top-24"><a
            :class="{'font-size-11': isMobile}"
            class="link is-pulled-right"
            href="#" @click.prevent="showFullCompareDescText">Show more</a></p>
      </div>
    </div>
  </div>
</template>
<script>
import {adConfig, misc} from '@/mixins'
import {AlertMessage, FlashMessage, BizNoResult, Ad, FuseAd} from '@/components'
import {BulmaDropdown} from '@/components/dropdowns'
import {mapActions, mapState} from 'pinia'
import {useIndustryStore} from '@/stores'
import BizRowCard from './BizRowCard'

export default {
  name: 'IndustryDetailRender',
  props: {
    indSlug: {
      type: String,
      required: true
    },
    subIndSlug: {
      type: String,
      default: ''
    }
  },
  components: {
    BizRowCard,
    Ad,
    FuseAd,
    AlertMessage,
    BulmaDropdown,
    FlashMessage,
    BizNoResult
  },
  mixins: [adConfig, misc],
  created () {
    this.fetchIndustries().then(_ => {
      this.industryDetail = this.getIndustry(this.indSlug)
    })
    this.getBizList(false)
  },
  mounted () {
    // this.loadFuseAds()
    // this.loadAds()
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: this.metaDescription,
      bodyAttrs: {
        class: 'industry'
      },
      link: [
        {
          rel: 'canonical',
          href: `${window.location.protocol}//${window.location.host}${this.$route.path}`
        },
        {
          rel: 'next',
          href: `${window.location.protocol}//${window.location.host}${this.$route.path}`
        },
        {
          rel: 'prev',
          href: `${window.location.protocol}//${window.location.host}${this.$route.path}`
        }
      ]
    }
  },
  data () {
    return {
      pagingTrack: {
        currentPage: 1,
        logs: {}
      },
      bizListFilers: {
        bizStatus: 'all',
        sortBy: 'most_relevant',
        startFrom: 0,
        indSlug: this.indSlug
      },
      industryDetail: {},
      bizStatusDd: {
        label: 'Business status',
        options: [
          {
            label: 'All',
            value: 'all',
            selected: true
          },
          {
            label: 'Verified Business',
            value: 'verified_business',
            tooltip: {content: 'Businesses that have verified additional details (e.g. registering a bank account when purchasing a subscription).'}
          },
          {
            label: 'Claimed Business',
            value: 'claimed_business',
            tooltip: {content: 'Businesses that have claimed their Hellopeter profile.'}
          }
        ]
      },
      sortByDd: {
        label: 'Sort by',
        options: [
          {
            label: 'Most relevant',
            value: 'most_relevant',
            selected: true,
            tooltip: {content: 'Sorting by relevance shows all companies that are best in a category, ordered by TrustIndex.'}
          },
          {
            label: 'Most reviews',
            value: 'most_reviews',
          },
          {
            label: 'Reply time',
            value: 'reply_time'
          }
        ]
      },
      compareDescTextRaw: `Hellopeter makes it easier than ever to
          compare insurance companies online. In South
          Africa, insurance has
          become almost mandatory to get full peace of mind. Whether seeking home insurance, car insurance or business
          insurance, finding the best insurance company in South Africa makes all the difference. There are many factors
          that affect insurance ratings, from service to claims efficiency.

          If you are concerned that you are not dealing with a legitimate insurance company, or you have business, home
          or car insurance complaints, you may find that writing an insurance review online gives you peace of mind.

          Review Insurance Companies Online
          What are some of the most common challenges faced by insurance customers? You may have a single issue, or an
          entire list of insurance concerns. Major business, car and home insurance complaints include the following:

          Service issues. It is frustrating enough having to follow up on a claim that has not been processed in months.
          Even if your provider is not the worst insurance company, poor service can lead to lack of communication,
          customers being ignored and plenty of stress, not to mention poor insurance ratings. On the flipside, if you
          have experienced great service, you can leave reviews to help consumers find the best insurance companies.

          Claims issues. With the endless amount of paperwork entailed in submitting your claim, you should not have to
          waste even more time trying to get paid out. When claims are not processed properly, or not processed at all,
          the result is a lack of trust in the insurer to genuinely speak for customers. Companies that make big, empty
          promises to no avail quickly lose their standing, while racking up poor reviews.

          Admin issues. Along with with claims problems, admin issues can be equally stressful. Unauthorised deductions,
          debit orders being duplicated or not going off, strange charges, policies not being updated, incorrect details
          being added to claims and other similar issues also lead to distrust when they are not resolved by house, car
          and business insurance companies.
          Writing an online insurance review may not result in a response, but the review process is transparent,
          meaning that your concern will be seen by our huge following of consumers. If you are a company meanwhile, you
          will be able to join, view and respond to reviews.

          Write an insurance review right now, browse current reviews, view ratings on insurance companies, or view our
          handy FAQ to learn more about how to submit an insurance company review on Hellopeter.com.`,
      compareDescCharsShow: 479
    }
  },
  computed: {
    ...mapState(useIndustryStore, ['isFetchingIndustryBusinesses', 'industryBusinesses']),

    showRanking () {
      return this.bizListFilers.bizStatus === 'all' && this.bizListFilers.sortBy === 'most_relevant'
    },
    subIndustryDetail () {
      if (this.subIndSlug && Object.keys(this.industryDetail).length) {
        return this.industryDetail.sub_industries.find(subIndustry => subIndustry.slug === this.subIndSlug) || null
      }
      return null
    },
    nameForBestIn () {
      if (this.subIndSlug && this.subIndustryDetail !== null) {
        return this.subIndustryDetail.name
      }

      if (!this.subIndSlug && Object.keys(this.industryDetail).length) {
        return this.industryDetail.name
      }

      return ''
    },
    compareDescTextTrimmed () {
      return this.compareDescTextRaw.substring(0, this.compareDescCharsShow)
    },
    metaTitle () {
      if (this.subIndSlug && this.subIndustryDetail !== null) {
        return `Compare the best ${this.subIndustryDetail.name} in South Africa`
      }

      if (!this.subIndSlug && Object.keys(this.industryDetail).length) {
        if (this.industryDetail.meta_title !== null) {
          return this.industryDetail.meta_title
        }
        return `Compare the best ${this.industryDetail.name} in South Africa`
      }

      return ''
    },
    metaDescription () {
      let metaDesc
      if (this.subIndSlug && this.subIndustryDetail !== null) {
        metaDesc = `Use Hellopeter to find and compare the best ${this.subIndustryDetail.name} in South Africa. From Cape Town to Johannesburg, our reviews help you find ${this.subIndustryDetail.name} online.`
      } else if (!this.subIndSlug && Object.keys(this.industryDetail).length) {
        if (this.industryDetail.meta_description !== null) {
          metaDesc = this.industryDetail.meta_description
        }
        metaDesc = `Use Hellopeter to find and compare the best ${this.industryDetail.name} in South Africa. From Cape Town to Johannesburg, our reviews help you find ${this.industryDetail.name} online.`
      } else {
        metaDesc = ''
      }

      const metaObjects = []
      if (metaDesc.length > 0) {
        metaObjects.push({name: 'description', content: metaDesc})
      }
      if (this.$route.query.page) {
        metaObjects.push({name: 'ROBOTS', content: 'NOINDEX, FOLLOW'})
      }
      return metaObjects
    },

    industriesAndBusinessesLoaded () {
      const businessesLoaded = parseInt(this.industryBusinesses.businesses.length)
      return `${businessesLoaded}`
    }
  },
  methods: {
    ...mapActions(useIndustryStore, ['getIndustry', 'fetchIndustries', 'fetchIndustryBusinesses', 'fetchSubIndustryBusinesses']),

    calcBizRank (rowIdx) {
      return (this.pagingTrack.currentPage - 1) * 10 + 1 + rowIdx
    },
    prevPageHandler () {
      this.pagingTrack.currentPage--
      this.bizListFilers.startFrom = this.pagingTrack.logs[`page-${this.pagingTrack.currentPage}`].startFrom
    },
    nextPageHandler () {
      this.bizListFilers.startFrom = this.pagingTrack.logs[`page-${this.pagingTrack.currentPage}`].endAt + 1
      this.pagingTrack.currentPage++
    },
    getBizList (scrollToList = true) {
      let resp
      if (this.subIndSlug) {
        resp = this.fetchSubIndustryBusinesses(this.subIndSlug, this.bizListFilers)
      } else {
        resp = this.fetchIndustryBusinesses(this.bizListFilers)
      }
      resp.then(_ => {
        this.pagingTrack.logs[`page-${this.pagingTrack.currentPage}`] = {
          startFrom: this.industryBusinesses.startFrom,
          endAt: this.industryBusinesses.endAt
        }
        if (scrollToList) {
          this.$refs.bizList.scrollIntoView({behavior: "instant"})
        }
      }).catch(_ => {
        flash('There was an error fetching the businesses. Please try again later!', 'is-danger')
      })
    },
    bizStatusChangeHandler (data) {
      this.bizListFilers.bizStatus = data.value
      this.resetPaging()
    },
    sortChangeHandler (data) {
      this.bizListFilers.sortBy = data.value
      this.resetPaging()
    },
    resetPaging () {
      this.pagingTrack = {
        currentPage: 1,
        logs: {}
      }
      this.bizListFilers.startFrom = 0
    },
    showFullCompareDescText () {
      this.compareDescCharsShow = 999999
    }
  },
  watch: {
    bizListFilers: {
      handler () {
        this.getBizList()
      },
      deep: true
    },
    industriesAndBusinessesLoaded () {
      window.prerenderReady = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.industries-columns {
  max-width: 1125px;
  color: map-get($colors, 'gray');
  margin: 8rem auto 2rem;

  @include mobile {
    font-size: 12px;
    padding: 0 22px 0 29px;
  }
}

strong {
  color: map-get($colors, 'gray');
}

.no-results {
  text-align: center;
  font-weight: 600;
  padding-top: 19px;
  padding-bottom: 32px;
  max-width: 650px;
  margin: auto;

  @include tablet {
    font-size: 14px;
    max-width: 573px;
  }

  @include mobile {
    max-width: 266px;
  }

  img {
    padding-top: 38px;
    padding-bottom: 36px;
  }
}

.results-ended {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  padding-top: 14px;
  padding-bottom: 32px;

  @include not-desktop {
    font-size: 16px;
  }

  img {
    padding-top: 38px;
    padding-bottom: 30px;
  }
}

.compareBox {
  background-color: map-get($colors, 'gray-light');

  &__cont {
    max-width: 1125px;
    margin: 0 auto;
    padding: 28px 0 38px;

    @include mobile {
      padding: 20px 36px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/industries/IndustryDetailRender.vue